import axios from 'axios';
import { useEffect} from 'react';


export default function Main(){

useEffect(()=>{
    const data ={'texto':'voto', 'sala':'SG,SUP', 'medio':'JDC,JRC', 'anio':'2022,2021', 'consecutivo':148}
    axios.post('http://10.10.106.26/web_api/api/expedientes/consulta', data).then((response) => {
        console.log(response.data);
        
    }).catch(err => console.warn(err));   
},[]);

    return(
        <>   
         
        </>
    )
}